import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TPostAccrualPolicyUsageWLRequestSchema,
  TPostAccrualPolicyUsageWLResponseSchema,
} from "./postAccrualPolicyUsageWL.schema";

export const postAccrualPolicyUsageWL = (axios: IAxiosInstance) => {
  return async ({
    companyID,
    id,
    employees,
  }: TPostAccrualPolicyUsageWLRequestSchema) => {
    const { data } = await axios.noRetry.post<
      IApiResponse<TPostAccrualPolicyUsageWLResponseSchema>
    >(`/accrual-policies/${id}/usage?companyID=${companyID}`, {
      employees,
    });

    if (data.success) {
      return data.data;
    }

    throw new Error("Something went wrong");
  };
};
